import React, { Component, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationIcon } from '@heroicons/react/outline'
import { FormattedMessage } from 'react-intl';
import orderService from './OrderService';
import { BaseCombobox } from '../controls/BaseCombobox';
import { BaseTextArea } from '../controls/BaseTextArea';
import { OrderStatus, RejectReasonJsonData } from '../infrastructure/AppConstants';

export class RejectReasonDialog extends Component {
    static displayName = RejectReasonDialog.name;

    constructor(props) {
        super(props);
        this.data = RejectReasonJsonData;
        var categories = this.data.categories;
        var selectedCategory = categories[0].name;
        var issues = categories[0].issues;
        var selectedIssue = issues[0].name;
        var descriptions = issues[0].descriptions;
        var selectedDesc = descriptions && descriptions.length > 0 ? descriptions[0] : '';

        this.state = { categories: categories, selectedCategory: selectedCategory, issues: issues, selectedIssue: selectedIssue, descriptions: descriptions, selectedDesc: selectedDesc, open: false, remark: "" };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleSelectIssueChange = this.handleSelectIssueChange.bind(this);
        this.handleSelectDescChange = this.handleSelectDescChange.bind(this);
        this.onChange = this.onChange.bind(this);
    }
    onChange(e) {
        const target = e.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });

    }
    handleSelectDescChange(e) {
        var target = e.target;
        var value = target.value;
        this.setState({ selectedDesc: value });
    }

    handleSelectIssueChange(e) {
        var target = e.target;
        var value = target.value;
        var issues = this.state.issues;
        var descriptions = [];
        var selectedDesc = '';
        for (var i = 0; i < issues.length; i++) {
            if (value === issues[i].name) {
                descriptions = issues[i].descriptions;
                selectedDesc = descriptions && descriptions.length > 0 ? descriptions[0] : '';
                break;
            }
        }
        this.setState({ selectedIssue: value, descriptions: descriptions, selectedDesc: selectedDesc });
    }

    handleSelectChange(e) {
        var target = e.target;
        var value = target.value;
        var categories = this.data.categories;
        var issues = [];
        var descriptions = [];
        let selectedIssue = '';
        let selectedDesc = '';
        for (var i = 0; i < categories.length; i++) {
            if (value === categories[i].name) {
                if (categories[i].flag) {
                    issues = categories[i].issues.filter(x => x.orderStatus == this.props.orderStatus);
                } else {
                    issues = categories[i].issues;
                }
                selectedIssue = issues[0].name;
                descriptions = issues[0].descriptions;
                selectedDesc = descriptions && descriptions.length > 0 ? descriptions[0] : '';
                break;
            }
        }
        this.setState({ selectedCategory: value, issues: issues, selectedIssue: selectedIssue, descriptions: descriptions, selectedDesc: selectedDesc });
    }

    handleClose() {
        this.setState({ open: false });
    }
    async handleClick(e) {
        e.preventDefault();

        this.setState({ open: true });
    }

    async componentDidMount() {

    }

    async handleSubmit(e) {
        e.preventDefault();

        //  send request to the server
        await orderService.rejectOrder(this.state, this.props.orderStatus);
        this.setState({ open: false });
        window.history.back(-1);
    }

    render() {
        const { open, categories, selectedCategory, issues, selectedIssue, descriptions, selectedDesc } = this.state;
        return (<button onClick={this.handleClick} className="mx-2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            <FormattedMessage id={this.props.orderStatus == OrderStatus.Cancel ? "Cancel" : "Retreat"} />
            <Transition.Root show={open} as={Fragment}>
                <Dialog
                    as="div"
                    static
                    className="fixed z-10 inset-0 overflow-y-auto"
                    open={open}
                    onClose={this.handleClose}>
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                    <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-yellow-200 sm:mx-0 sm:h-10 sm:w-10">
                                            <ExclamationIcon className="h-6 w-6 text-yellow-700" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                            <Dialog.Title as="h3" className="text-lg text-left leading-6 font-medium text-gray-900 mt-2">
                                                {this.props.orderStatus == OrderStatus.Cancel ? <FormattedMessage id="SelectCancelReason" /> : <FormattedMessage id="SelectRejectReason" />}
                                            </Dialog.Title>
                                        </div>
                                    </div>
                                    <div className="mt-4 mb-4 px-2 sm:mt-0 sm:ml-4 w-full">
                                        <div className="p-4">
                                            <label className="inline-block mr-3"><FormattedMessage id="RejectReasonCategory" /></label>
                                            <BaseCombobox classnames="mt-1" onChange={this.handleSelectChange} value={selectedCategory}>
                                                {categories.map(c => <option value={c.name}>{c.name}</option>)}

                                            </BaseCombobox>
                                        </div>
                                        <div className="p-4">
                                            <label className="inline-block mr-3"><FormattedMessage id="Issue" /></label>
                                            <BaseCombobox classnames="mt-1" onChange={this.handleSelectIssueChange} value={selectedIssue} >
                                                {issues.map(i => <option value={i.name}>{i.name}</option>)}
                                            </BaseCombobox>
                                        </div>
                                        <div className="p-4">
                                            <label className="inline-block mr-3"><FormattedMessage id="Description" /></label>
                                            <BaseCombobox classnames="mt-1" onChange={this.handleSelectDescChange} value={selectedDesc} >
                                                {descriptions && descriptions.map(i => <option value={i}>{i}</option>)}

                                            </BaseCombobox>
                                        </div>
                                        <div className="p-4">
                                            <label className="inline-block mr-3"><FormattedMessage id="Remark" /></label>
                                            <BaseTextArea classnames="mt-1" id="remark" name="remark" value={this.state.remark} onChange={this.onChange}>

                                            </BaseTextArea>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">

                                    <button
                                        type="button"
                                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                        onClick={this.handleClose} >
                                        <FormattedMessage id="Cancel" />
                                    </button>
                                    <button
                                        type="button"
                                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"
                                        onClick={this.handleSubmit}>
                                        <FormattedMessage id="Submit" />
                                    </button>
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition.Root>
        </button>
        );
    }
}
